/**
 * RTWO Cryptography & Identity Engine — Scaffold Identity Backend
 *
 * Base for identity backend scaffolds. No identities or trust records fabricated.
 */

import type {
  IdentityId,
  IdentityType,
  RTWOIdentity,
  RTWOTrustRecord,
  TrustLevel,
  TrustSource,
} from '../domain-models';
import type {
  IIdentityBackend,
  IdentityBackendStatus,
  IdentityBackendType,
  IdentityRegistrationProviderResult,
  RTWOIdentityBackendDescriptor,
} from '../adapters/identity-backend-interface';

export abstract class ScaffoldIdentityBackend implements IIdentityBackend {
  abstract readonly backendId: string;
  abstract readonly backendName: string;
  abstract readonly backendType: IdentityBackendType;
  abstract readonly scaffoldMessage: string;

  protected status: IdentityBackendStatus = 'not_configured';

  async connect(): Promise<void> {
    this.status = 'connecting';
    this.status = 'error';
  }

  async disconnect(): Promise<void> {
    this.status = 'disconnected';
  }

  getStatus(): IdentityBackendStatus {
    return this.status;
  }

  isReady(): boolean {
    return false;
  }

  async registerIdentity(
    _keyPairId: string,
    _identityType: IdentityType,
    _metadata?: Record<string, string>
  ): Promise<IdentityRegistrationProviderResult | null> {
    return null;
  }

  async getIdentity(_identityId: IdentityId): Promise<RTWOIdentity | null> {
    return null;
  }

  async verifyIdentity(_identityId: IdentityId): Promise<boolean> {
    return false;
  }

  async updateIdentityStatus(
    _identityId: IdentityId,
    _status: RTWOIdentity['status']
  ): Promise<boolean> {
    return false;
  }

  async createTrustRecord(
    _identityId: IdentityId,
    _trustLevel: TrustLevel,
    _source: TrustSource
  ): Promise<RTWOTrustRecord | null> {
    return null;
  }

  async updateTrustLevel(
    _trustRecordId: string,
    _trustLevel: TrustLevel
  ): Promise<RTWOTrustRecord | null> {
    return null;
  }

  getDescriptor(): RTWOIdentityBackendDescriptor {
    return {
      backendId: this.backendId,
      backendName: this.backendName,
      backendType: this.backendType,
      status: this.status,
      isConfigured: this.backendType !== 'not_configured',
      configuredAt: null,
      description: this.scaffoldMessage,
    };
  }
}
